let language = {

    BULK_ORDER_STEP_SHIPPING_SHIPPING_ADDRESS: "Shipping address:",
    BULK_ORDER_STEP_SHIPPING_CHANGE_ADDRESS: "CHANGE ADDRESS",
    BULK_ORDER_STEP_SHIPPING_BILLING_ADDRESS: "Billing address:",
    BULK_ORDER_STEP_SHIPPING_SHIPPING_METHOD: "Shipping method:",
    BULK_ORDER_STEP_SHIPPING_CHANGE_SHIPPING: "CHANGE SHIPPING",
    BULK_ORDER_STEP_SHIPPING_ESTIMATED_DELIVERY_TIME_TITLE: "Estimated delivery time:",
    BULK_ORDER_STEP_SHIPPING_ESTIMATED_DELIVERY_TIME_CONTENT: `
        Production time {{productionMinDay}} - {{productionMaxDay}} working days + transportation time {{deliveryMinDay}} - {{deliveryMaxDay}} working days.
    `,
    BULK_ORDER_STEP_SHIPPING_ESTIMATED_RECEIPT_TIME_TITLE: "Estimated receipt time:",
    BULK_ORDER_STEP_SHIPPING_ADD_REMARK: "ADD REMARK",
    BULK_ORDER_STEP_SHIPPING_EDIT_REMARK: "EDIT REMARK",

    BULK_ORDER_STEP_SHIPPING_PRICE: "Price:",
    BULK_ORDER_STEP_SHIPPING_WEIGHT: "Weight:",
    BULK_ORDER_STEP_SHIPPING_TOTAL_PRICE: "Total Price:",
    BULK_ORDER_STEP_SHIPPING_TOTAL_WEIGHT: "Total Weight:",
    BULK_ORDER_STEP_SHIPPING_TAX: "Tax:",
    BULK_ORDER_STEP_SHIPPING_SHIPPING_PRICE: "Shipping:",
    BULK_ORDER_STEP_SHIPPING_PRODUCT_PRICE: "Products and Services:",
    BULK_ORDER_STEP_SHIPPING_IMPORT_SERVICE_FEE: "Import Service:",
    BULK_ORDER_STEP_SHIPPING_TOTAL_DUE: "Total Due:",

    BULK_ORDER_STEP_SHIPPING_ORDER_TOTAL_TAX: "Total Tax:",
    BULK_ORDER_STEP_SHIPPING_ORDER_TOTAL_SHIPPING: "Total Shipping:",

    BULK_ORDER_STEP_SHIPPING_ORDER_DISCOUNTS: `Coupon( {{OrderCouponName}} ):`,

    BULK_ORDER_STEP_SHIPPING_ORDER_TOTAL_IMPORT_SERVICE_FEE: "Total Import Service:",
    BULK_ORDER_STEP_SHIPPING_ORDER_TOTAL_PRICE: "Total Due:",
    BULK_ORDER_STEP_SHIPPING_ORDER_TOTAL_PRODUCT_PRICE: "Total Products and Services:",

    BULK_ORDER_STEP_NONE_CONTENT: "None",

};

export { language }